import { render, staticRenderFns } from "./InvitationsList.vue?vue&type=template&id=61b1e717&scoped=true&"
import script from "./InvitationsList.vue?vue&type=script&lang=js&"
export * from "./InvitationsList.vue?vue&type=script&lang=js&"
import style0 from "./InvitationsList.vue?vue&type=style&index=0&id=61b1e717&lang=scss&scoped=true&"
import style1 from "./InvitationsList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b1e717",
  null
  
)

export default component.exports